import React from 'react';
import { CLAN_STATUS, CLAN_RECRUITING_STATUS } from '../../metadata/fields.js';

const STRINGS = {
    MEMBERSHIP_POLICY: gettext("Membership Policy: "),
    TO_CLAN_ROSTER: gettext("To Regiment Roster"),
}

function ClanStatsHeader({ clanDetails }) {
    return(
        <section>
            <h1>{clanDetails?.name ?? ''} <span className="orange-text">{ clanDetails?.tag ? '[' + clanDetails?.tag + ']' : ''}</span></h1>
            { clanDetails?.status === 'active' ?
                <>
                    <br/>
                    <a href={"/clans/" + clanDetails?.tag}> {STRINGS.TO_CLAN_ROSTER} </a>
                    <br/>
                    <br/>
                    <span>{STRINGS.MEMBERSHIP_POLICY} {CLAN_RECRUITING_STATUS[clanDetails?.game_data?.recruiting_policy] ?? ''}</span>
                </>
                :
                <>
                    <br/>
                    <br/>
                    <h2>{ CLAN_STATUS[clanDetails?.status] ?? '' }</h2>
                </>
            }
            
        </section>
    )
}

export default ClanStatsHeader;
